<template>
    <!-- eslint-disable max-len -->
    <v-row>
      <v-col>
        <!-- title section -->
        <div class="mt-0">
          <p class="title" v-bind:class="{'primary--text': !isSummaryView}">
            <span class="font-weight-black">
              {{ driver.question }}
            </span>
            <span v-if="driver.example" class="font-weight-light">
              {{ driver.example }}
            </span>
          </p>
        </div>

        <!-- score -->

        <v-row class="d-none d-sm-inline-flex" justify="center" no-gutters>
          <v-radio-group v-model="rating"
                         :rules="[v => (currentStep !== this.$props.pageNr || (!!v) || this.isRatingSelected()) || 'Please select rating.']"
                         row
                         :disabled="isSummaryView">
            <v-radio v-for="i in 7"
                     :key="i"
                     class="large"
                     on-icon="mdi-checkbox-marked-circle"
                     color="primary"
                     :value="i"></v-radio>
            <v-radio v-if="!isSelfSurvey"
                     key="99"
                     class="large"
                     on-icon="mdi-checkbox-marked-circle"
                     color="primary"
                     value="99"></v-radio>
          </v-radio-group>
        </v-row>

        <v-row class="d-flex d-sm-none" justify="center" no-gutters>
          <v-radio-group v-model="rating"
                         :rules="[v => (currentStep !== this.$props.pageNr || (!!v) || this.isRatingSelected()) || 'Please select rating.']"
                         row
                         :disabled="isSummaryView">
            <v-radio v-for="i in 7"
                     :key="i"
                     class="small"
                     on-icon="mdi-checkbox-marked-circle"
                     color="primary"
                     :value="i"></v-radio>
            <v-radio v-if="!isSelfSurvey" key="99"
                     class="small"
                     on-icon="mdi-checkbox-marked-circle"
                     color="primary"
                     value="99"></v-radio>
          </v-radio-group>
        </v-row>
        <v-row class="d-none d-sm-inline-flex radio-bottom-labels caption">
            <div class="text-center adj-label-large">Strongly Disagree</div>
            <div class="text-center adj-label-large">Disagree</div>
            <div class="text-center adj-label-large">Slightly Disagree</div>
            <div class="text-center adj-label-large">Neither Agree Nor Disagree</div>
            <div class="text-center adj-label-large">Slightly Agree</div>
            <div class="text-center adj-label-large">Agree</div>
            <div class="text-center adj-label-large">Strongly Agree</div>
            <div v-if="!isSelfSurvey" class="text-center adj-label-large">Not Applicable</div>
        </v-row>
        <v-row  v-if="!isSelfSurvey" class="d-flex d-sm-none caption" no-gutters>
          <v-col cols="3">
            <p class="text-left adj-label-small">Strongly Disagree</p>
          </v-col>
          <v-col cols="4">
            <p class="text-center adj-label-small">Neither Agree Nor Disagree</p>
          </v-col>
          <v-col cols="3">
            <p class="text-right adj-label-small">Strongly Agree</p>
          </v-col>
          <v-col cols="2" >
            <p class="text-center adj-label-small">NA</p>
          </v-col>
        </v-row>
        <v-row v-if="isSelfSurvey" class="d-flex d-sm-none caption" no-gutters>
          <v-col cols="4">
            <p class="text-left adj-label-small">Strongly Disagree</p>
          </v-col>
          <v-col cols="4">
            <p class="text-center adj-label-small">Neither Agree Nor Disagree</p>
          </v-col>
          <v-col cols="4">
            <p class="text-right adj-label-small">Strongly Agree</p>
          </v-col>
        </v-row>
        <div>
        </div>
        <!-- comments -->
      </v-col>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Driver',

  props: ['driver', 'pageNr', 'isSummaryView'],

  data() {
    return {
    };
  },

  methods: {
    storeResponse(responseField, responseValue) {
      this.$store.commit('storeResponse', responseField, responseValue);
    },
    clearResponse() {
      this.rating(null);
      this.$store.commit('storeResponse', `${this.driver.field}_Rating`, null);
    },
    isRatingSelected() {
      const ratingValue = this.getRating();
      return ratingValue !== undefined && ratingValue != null;
    },
    getRating() {
      return this.$store.state.response[`${this.driver.field}_Rating`];
    },
    manualValidateForm() {
      this.$emit('validate-form');
    },
  },

  computed: {
    ...mapGetters([
      'currentStep',
      'isSelfSurvey',
    ]),
    params() {
      return this.$store.state.params;
    },
    // Survey Responses
    rating: {
      get() {
        return this.getRating();
      },
      set(newValue) {
        this.$store.commit('storeResponse', {
          k: `${this.driver.field}_Rating`,
          v: newValue,
        });
      },
    },
  },
  mounted() {
    if (this.driver.question.indexOf('{') > -1) {
      const keys = Object.keys(this.$store.state.params);
      for (let i = 0; i < keys.length; i += 1) {
        this.driver.question = this.driver.question.replace(`{${keys[i]}}`, this.$store.state.params[keys[i]]);
      }
    }
  },
};
</script>

<style scoped>
.large {
  transform: scale(1.8);
  transform-origin: left;
}

.small {
  transform: scale(1.3);
  transform-origin: left;
}

.small.v-radio {
  margin-right: 7.5px;
}

.large.v-radio {
  margin:0 26px;
}
.radio-bottom-labels {
  margin-top: -40px;
  margin-left:2.5px;
}
.adj-label-large {
  width: 75px;
  margin: 5px;
}

.adj-label-small {
  margin: 2.5px;
}

</style>
